<template>
  <div class="form-group"
    :class="[wrapperClass, {
      'input-group': hasIcon,
      'input-group-focus': focused,
      'text-danger': vuelidateIns,
      'text-warning': warning,
    }]"
  >
    <slot name="label">
      <label v-if="label" class="control-label">
        <span class="label">
          {{label}}

          <span v-if="hasRequired" class="asterisk">
            *
          </span>
        </span>
      </label>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-prepend">
        <div class="input-group-text">
          <i :class="addonLeftIcon"></i>
        </div>
      </span>
    </slot>
    <div class="ske-wrapper" :class="contentWrapperClass">
      <slot
        :listeners="listeners"
        :ske="ske"
        :vuelidateIns="vuelidateIns"
        :value="value"

        :attrs="{id, ...$attrs}"
      ></slot>
      <div v-if='ske' class="ske"></div>
    </div>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-append">
        <div class="input-group-text">
          <i :class="addonRightIcon"></i>
        </div>
      </span>
    </slot>
    <HandleVuelidateError v-if="vuelidateIns"
      :ins="vuelidateIns"
    />
    <slot name="helperText"></slot>
  </div>
</template>

<script>

import HandleVuelidateError from './HandleVuelidateError.vue'

export const props = {
  vuelidate: Object,
  fieldName: String,
  default: [String, Boolean, Number],
  ske: Boolean,
  warning: Boolean,
  contentWrapperClass: String,

  id: {
    type: String,
    required: false,
  },
  wrapperClass: {
    type: [String, Array, Object],
    required: false,
  },
  lowercase: {
    type: Boolean,
    required: false,
  },
  oneWayBind: Boolean,

  label: {
    type: String,
    description: "Input label"
  },
  value: {
    type: [String, Number, Object, Array, Boolean, File],
    description: "Input value"
  },
  addonRightIcon: {
    type: String,
    description: "Input icon on the right"
  },
  addonLeftIcon: {
    type: String,
    description: "Input icon on the left"
  },
}

export default {
  components: {
    HandleVuelidateError,
  },
  inheritAttrs: false,
  props: { ...props },
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      focused: false
    }
  },
  created() {
    if (this.default) {
      this.$emit("input", this.default)
    }
  },
  computed: {
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      }
    },
    vuelidateIns() {
      const ins = this.vuelidate && this.vuelidate[this.fieldName]
      return ins && ins.$error && ins
    },
    hasRequired() {
      return this.vuelidate && this.fieldName && this.vuelidate[this.fieldName].$params.required
    },
  },
  methods: {
    onInput(val) {
      const str = (typeof val === "string" || !val.target) ? val : val.target.value
      this.$emit('input', this.lowercase ? str.toLowerCase() : str)
    },
    onFocus() {
      this.focused = true;
      this.$emit("focus")
    },
    onBlur() {
      this.focused = false;
      this.$emit("blur")
    }
  }
}

</script>


<style scoped>

.control-label {
  position: relative;
  font-size: 1.08em !important;
  font-weight: 450;
  margin-bottom: 2px;
  color: #000000;
}

.form-group, .ske-wrapper {
  position: relative;
}

.asterisk {
  display: block;
  position: absolute;
  left: 100%;
  top: 0;
  margin-top: -2px;
  margin-left: 4px;
}

.ske {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

</style>
